<template>
  <div class="shadow rounded-1">
    <h2 class="text-center pt-3">Jumlah Hasil Penilaian per Kategori ({{ filterTahun }})</h2>
    <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
    <p v-if="!hasResults" class="text-center text-secondary pb-3 mb-0">Belum ada hasil penilaian pada periode ini.</p>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: { apexchart: VueApexCharts },
  props: {
    summary: { type: Object, required: true },
    filterTahun: { type: [Number, String], required: true },
  },
  computed: {
    values() {
      return [this.summary.taat, this.summary.taatDenganCatatan, this.summary.tidakTaat]
    },
    hasResults() {
      return this.values.some((value) => value > 0)
    },
    series() {
      return [{ name: 'Jumlah Hasil Penilaian', data: this.values }]
    },
    chartOptions() {
      return {
        chart: {
          stacked: true,
          toolbar: { show: true },
        },
        plotOptions: {
          bar: {
            columnWidth: '80%',
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                style: { color: '#777777' },
              },
            },
          },
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: ['Taat', 'Taat dengan Catatan', 'Tidak Taat'],
        },
        yaxis: {
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: { style: { colors: '#78909c' } },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: { position: 'bottom', offsetX: -10, offsetY: 0 },
            },
          },
        ],
      }
    },
  },
}
</script>
